/**
 * Pobiera lub wysyła informacje oraz parsuje odpowiedź z JSON-a.
 * @param url - Adres docelowy
 * @param obj - Obiekt do przesłania
 * @param mode - Ustawia metodę w jaki sposób chcemy przesłać informacje
 * @param rethrowErrors - Czy przerzucać błędy? W innym przypadku, zwraca pusty obiekt
 */
function serverFetch<T = any>(url: string, obj: any = {}, mode = 'GET', rethrowErrors = false, parse = true): Promise<T> {
	// TODO: dodaj parametr rzeby rzócało błendem, zamiast zwracało pusty obiekt.
	return new Promise((resolve, reject) => {
		const f:RequestInit = { method: mode, mode: 'no-cors', credentials: 'include' };
		if (obj && Object.keys(obj).length) {
			const d = new FormData();
			for (const k in obj) {
				const keyname = k.indexOf('|') > -1 ? (k.split('|')[0]) : k;
				if (Array.isArray(obj[k])) {
					obj[k].forEach((i) => { d.append(keyname, i); });
				} else {
					d.append(keyname, obj[k]);
				}
			}
			f.body = d;
		}

		fetch(url, f)
			.then((rsvp) => rsvp.json())
			.then((rsvp) => {
				if (parse) {
					rsvp = JSON.parse(rsvp);
					resolve(rsvp);
				} else {
					resolve(rsvp);
				}
			}).catch((err) => {
				if (rethrowErrors) {
					reject(err);
				} else {
					resolve({});
				}
			});
	});
}

export default serverFetch;
